export const calculateRequestsTotalCount = (requests) => {
  let totalCount = 0;
  requests.forEach((request) => totalCount += +request.count);
  return totalCount;
};